import axios from "axios";
import { serverURL, headeroption, headeroptionupload } from "../http-common";

class TechnitionService {
  getallTechnition(data) {
    return axios.get(serverURL + "/technition-api?req=smarttableTechnition", {
      params: data,
      headers: headeroption,
    });
  }
  getallTechnition(data) {
    return axios.get(serverURL + "/technition-api?req=smarttableTechnition", {
      params: data,
      headers: headeroption,
    });
  }
  getTechnition(techn_id) {
    return axios.get(serverURL + "/technition-api?req=getTechnition", {
      params: { techn_id: techn_id },
      headers: headeroption,
    });
  }
  createTechnition(data) {
    return axios.post(serverURL + "/technition-api?req=createTechnition", data, {
      headers: headeroption,
    });
  }
  updateTechnition(data) {
    return axios.put(serverURL + "/technition-api?req=updateTechnition", data, {
      headers: headeroption,
    });
  }
  deleteTechnition(techn_id) {
    return axios.delete(serverURL + "/technition-api?req=deleteTechnition", {
      params: { techn_id: techn_id },
      headers: headeroption,
    });
  }
  deleteAll() {
    return axios.delete(serverURL + "/technition-api?req=deleteTechnition");
  }
  findByTitle(techn_fullname) {
    return axios.get(serverURL + "/technition/technition-api?name=" + techn_fullname);
  }
  upload(techn_id, data) {
    return axios.post(
      serverURL + "/uploads-api?req=singlefile&techn_id=" + techn_id,
      data,
      { headers: headeroptionupload }
    );
  }
  deletefile(techn_id, filename) {
    return axios.delete(serverURL + "/uploads-api?req=singledelete", {
      params: { techn_id: techn_id, filename: filename },
      headers: headeroption,
    });
  }
  uploads(techn_id, data) {
    return axios.post(
      serverURL + "/uploads-api/uploadmultifile?techn_id=" + techn_id,
      data,
      { headers: headeroptionupload }
    );
  }
}
export default new TechnitionService();
